<template>
  <div class="mod-config">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('offlinepayment.title') }}</span>
      </div>

      <el-form :inline="true" :model="searchForm" @keyup.enter.native="getDataList()">
        <el-form-item :label="$t('offlinepayment.coachName')">
          <el-input v-model="searchForm.jiaolianxingming" :placeholder="$t('offlinepayment.coachName')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('offlinepayment.customerName')">
          <el-input v-model="searchForm.xingming" :placeholder="$t('offlinepayment.customerName')" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList">{{ $t('offlinepayment.search') }}</el-button>
          <el-button @click="resetForm">{{ $t('offlinepayment.reset') }}</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%">
        <el-table-column prop="id" :label="$t('offlinepayment.appointmentId')" width="120" align="center" />
        <el-table-column prop="jiaolianxingming" :label="$t('offlinepayment.coachName')" align="center" />
        <el-table-column prop="xingming" :label="$t('offlinepayment.customerName')" align="center" />
        <el-table-column prop="shouji" :label="$t('offlinepayment.customerPhone')" width="140" align="center" />
        <el-table-column prop="startTime" :label="$t('offlinepayment.startTime')" width="180" align="center" />
        <el-table-column prop="endTime" :label="$t('offlinepayment.endTime')" width="180" align="center" />
        <el-table-column prop="price" :label="$t('offlinepayment.amount')" width="100" align="center" />
        <el-table-column :label="$t('offlinepayment.paymentMethod')" width="120" align="center">
          <template slot-scope="scope">
            <el-tag type="warning">{{ $t('offlinepayment.offlinePayment') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('offlinepayment.paymentStatus')" width="120" align="center">
          <template slot-scope="scope">
            <el-tag type="info">{{ $t('offlinepayment.pendingPayment') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('offlinepayment.operation')" width="160" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openHandleDialog(scope.row)">{{ $t('offlinepayment.handlePayment') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      />
    </el-card>

    <!-- 处理付款弹窗 -->
    <el-dialog :title="$t('offlinepayment.handleOfflinePayment')" :visible.sync="dialogVisible" width="500px">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="100px">
        <el-form-item :label="$t('offlinepayment.paymentHandler')" prop="paymentHandler">
          <el-input v-model="dataForm.paymentHandler" :placeholder="$t('offlinepayment.inputPaymentHandler')" />
        </el-form-item>
        <el-form-item :label="$t('offlinepayment.remark')" prop="paymentRemark">
          <el-input type="textarea" v-model="dataForm.paymentRemark" :placeholder="$t('offlinepayment.inputRemark')" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('offlinepayment.cancel') }}</el-button>
        <el-button type="primary" @click="submitHandle">{{ $t('offlinepayment.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
  
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        jiaolianxingming: '',
        xingming: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dialogVisible: false,
      dataForm: {
        id: null,
        paymentStatus: 1,
        paymentMethod: 2,
        paymentHandler: '',
        paymentRemark: ''
      },
      dataRule: {
        paymentHandler: [{ required: true, message: '请输入付款处理人', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.dataListLoading = true
      const params = {
        page: this.pageIndex,
        limit: this.pageSize,
        paymentStatus: 0,
        paymentMethod: 2,
        jiaolianxingming: this.searchForm.jiaolianxingming ? `%${this.searchForm.jiaolianxingming}%` : undefined,
        xingming: this.searchForm.xingming ? `%${this.searchForm.xingming}%` : undefined,
        sort: 'start_time',
        order: 'desc'
      }
      this.$http({ url: '/jiaolianyuyue/page', method: 'get', params }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list || []
          this.totalPage = data.data.total || 0
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg || '获取数据失败')
        }
        this.dataListLoading = false
      }).catch(() => {
        this.dataList = []
        this.totalPage = 0
        this.dataListLoading = false
        this.$message.error('获取数据失败')
      })
    },
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    resetForm() {
      this.searchForm = { jiaolianxingming: '', xingming: '' }
      this.getDataList()
    },
    openHandleDialog(row) {
      this.dataForm = {
        id: row.id,
        paymentStatus: 1,
        paymentMethod: 2,
        paymentHandler: '',
        paymentRemark: ''
      }
      this.dialogVisible = true
    },
    submitHandle() {
      this.$refs['dataForm'].validate(valid => {
        if (!valid) return
        this.$http({
          url: '/jiaolianyuyue/handleOfflinePayment',
          method: 'post',
          data: this.dataForm
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message.success('处理成功')
            this.dialogVisible = false
            this.getDataList()
          } else {
            this.$message.error(data.msg || '处理失败')
          }
        }).catch(() => {
          this.$message.error('处理失败')
        })
      })
    }
  }
}
</script>

<style scoped>
.box-card { margin-bottom: 20px; }
</style>




